﻿import $ from "jquery";

var contactUsButtonSelector = ".ccs-contact-button, .ccs-contact-button a";
var contactUsEmptySelector = ".ccs-contact-empty";

/* Enables "Contact Us" features.
----------------------------------------------------------*/
export default function enableContactUs(contactUs, options) {
	const context = options.context;
	const log = options.log;

	if (!contactUs.isEnabled)
		return $(contactUsEmptySelector).show();

	const $contactButtons = $(contactUsButtonSelector);
	$contactButtons.show();

	const $contactLinks = $contactButtons.filter("a");

	$contactLinks.each(function () {
		const $contactLink = $(this);
		const autoHeightId = new Date().getTime();
		const protocol = document.location.protocol === "https:" ? "https:" : "http:";
		const url = `${protocol}//${ccs_cc_initParams[1]}${contactUs.formUrl}${context}&AutoHeightId=${autoHeightId}`;

		$contactLink
			.addClass("iframe")
			.attr("href", url)
			.fancybox({
				type: "iframe",
				smallBtn: true,
				baseClass: "ccs-fancybox-dccn-features",
				iframe: {
					attr: {
						"data-autoheight-id": autoHeightId
					},
					css: { width: 430 }
				},
				afterLoad: function (instance, current) {
					current.$content.css("height", "auto");

					const logCall = log;
					const clientParams = {
						Action: "contact-us"
					};
					ccs_cc_log.dispatchEvent(logCall, clientParams);
				}
			});
	});
};
